import classNames from 'classnames'
import { forwardRef, TdHTMLAttributes, useContext } from 'react'

import { TableContext } from './context'

export const TableCellJustifies = ['start', 'center', 'end'] as const
export type TableCellJustify = (typeof TableCellJustifies)[number]
export type TableCellElement = HTMLTableCellElement

export type TableCellBaseProps = {
  justify?: TableCellJustify
}
export type TableCellProps = TdHTMLAttributes<TableCellElement> & TableCellBaseProps

const TableCell = forwardRef<TableCellElement, TableCellProps>(function TableCell(props, ref) {
  const { className, justify, ...rest } = props

  const { getCellStyles } = useContext(TableContext)

  const classes = classNames(getCellStyles({ justify }), className)
  return <td {...rest} className={classes} ref={ref} />
})

export default TableCell
